<template>
  <label
      :for="fieldId"
      :class="labelClass"
  >
    <span v-if="showlabel">{{ label }}</span>
    <input
        @input="(event) => $emit('update:checked', event.target.checked)"
        type="checkbox"
        :checked="checked"
        :data-value="valued"
        :id="fieldId"
        :class="'mr-2 hidden cb-group-' + namespace"
        :data-inline-label="label"
    />
    <span :class="'checkmark ' + className"></span>

  </label>
</template>

<script>
export default {
  data() {
    return {
      verticalClass: 'wrapper flex items-center',
      horizontalClass: 'wrapper wrapper-inline'
    }
  },
  props: {
    label: String,
    fieldId: {
      type: String,
      required: true,
    },
    valued: {
      type: String,
      required: false,
      default: '',
    },
    className: {
      type: String,
      required: false,
    },
    namespace: {
      type: String,
      required: false,
    },
    checked: {
      type: Boolean,
    },
    showlabel: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    labelClass() {
      if(this.showlabel) {
        return this.verticalClass
      } else {
        return this.horizontalClass
      }
    }
  }
};
</script>

<style lang="postcss" scoped>
/* Customize the label (the wrapper) */
.wrapper {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 6px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 16px;
}
/* Hide the browser's default checkbox */
.wrapper input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.wrapper-inline {
  display: inline-block;
}
/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 21px;
  width: 21px;
  border-radius: 2px;
  background: #666666;

  border: 1px solid #ccc;
}

/* On mouse-over, add a grey background color */
.wrapper:hover input ~ .checkmark {
  background-color: #ccc;
}
/* When the checkbox is checked, add a blue background */
.wrapper input:checked ~ .checkmark {
 /* background-color: #1CD4A7; */
}
/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
/* Show the checkmark when checked */
.wrapper input:checked ~ .checkmark:after {
  display: block;
}
/* Style the checkmark/indicator */
.wrapper .checkmark:after {
  left: 7px;
  top: 0px;
  width: 7px;
  height: 15px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>